import { Base2Presenter } from "core/presenter";
import { DiscountRepository } from "core/repository";
import { Discount } from "core/entity";

class DiscountInfoPresenter extends Base2Presenter {
  initialState() {
    return {
      loading: true,
      form: new Discount(),
      title: "Desconto"
    };
  }

  async onStart() {
    this.enqueue({ loading: true });

    await this.loadDiscount();

    this.enqueue({ loading: false });
  }

  async loadDiscount() {
    const discountResult = await this.getDiscount();

    if (discountResult.success) {
      this.enqueue({
        form: discountResult.data,
        title: discountResult.data.description
      });
    } else {
      this.sendNotification({
        type: "error",
        title: "Ooops",
        content:
          "Houve um problema ao carregar as informações do desconto. Por favor, tente novamente daqui uns minutos ou entre em contato com o suporte."
      });
    }
  }

  async getDiscount() {
    const discountUuid = this.routeParams.discountUuid;
    return await DiscountRepository.getOnline(discountUuid);
  }

  onGoBack() {
    this.navigateTo("app.registration.discount");
  }

  onGoEdit() {
    this.navigateTo("app.registration.discount.edit", {
      discountUuid: this.viewModel.form.uuid
    });
  }
}

export default DiscountInfoPresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/discount/info/presenter.js